<template>
  <!-- The PCSelectItemsPopup component to select a single work position -->
  <PCSelectItemsPopup
    v-model:opened="opened"
    :items="workPositions"
    :min-selections="1"
    :max-selections="1"
    :show-preload="isLoading"
    :preload-num="3"
    title="Seleccionar el puesto de trabajo del tickaje"
    item-title-prop="Descripcion"
    @apply="emitApply"
  />
</template>

<script setup>
// @ts-check

import { ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useAppConfigStore } from '@/js/stores/appConfig';
import { useRepairPartsStore } from '@/js/stores/repairParts';

import { HiNotification } from '@/js/common/HINotificationSupport';
import { logError } from '@/js/utils/log';
import { callFetchWorkPositions } from '@/js/services/repairs/ApiRepairs';

import PCSelectItemsPopup from '@/components/common/PCSelectItemsPopup.vue';

/** @import { PuestoTrabajo } from '@erpagroapp/types' */

const emit = defineEmits(['apply']);

const opened = defineModel('opened', {
  type: Boolean,
  default: false,
});

const isLoading = ref(false);

const { userEnviroment } = storeToRefs(useAppConfigStore());
const { workPositions } = storeToRefs(useRepairPartsStore());

/** Loads work positions from the API and updates the Store with the retrieved data. */
async function fetchWorkPositions() {
  if (!userEnviroment.value) {
    return;
  }

  try {
    isLoading.value = true;

    const groupId = userEnviroment.value.EntornoDeTrabajo.GrupoEmpresarial.Id;
    const { data } = await callFetchWorkPositions(groupId);

    if (Array.isArray(data)) {
      workPositions.value = data;
    } else {
      HiNotification.Toast('No se han podido obtener los puestos de trabajo');
    }
  } catch (error) {
    logError(error);
    HiNotification.Toast('No se han podido obtener los puestos de trabajo');
  } finally {
    isLoading.value = false;
  }
}

/**
 * Handles the 'apply' event when the user selects a work position in the popup.
 * Emits the 'apply' event with the selected work position.
 * @param {PuestoTrabajo[]} selectedWorkPositions - An array of the selected work position objects.
 */
function emitApply(selectedWorkPositions) {
  emit('apply', selectedWorkPositions[0]);
}

watch(opened, () => {
  if (opened.value && !workPositions.value) {
    fetchWorkPositions();
  }
});
</script>
